import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 0;\n  margin: 0;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  border-radius: 2px;\n  margin-bottom: -1px;\n  fill: ", ";\n  left: 45% !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-radius: ", ";\n  padding: 0;\n  border: none;\n  box-shadow: ", ";\n  margin-top: 13px;\n  background-color: ", ";\n  position: absolute;\n  transform: translateX(-50%);\n  left: 50%;\n  top: calc(100% + 12px);\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import { Popover } from 'reakit';
import styled from '../utils/styling/styled-components';
import { DROPDOWN_LIST } from '../utils/testing/TestIDs';
/**
 * DropdownMenu is the a combination of the little popup that appears
 * underneath the dropdown button that says "Core/Later/Spend" and the
 * little tooltip arrow above it. It looks a little something like:
 *
 *          /\
 *    ------  -------
 *    |  Core        |
 *    |  Later       |
 *    |  Spend       |
 *     ---------------
 *
 * It acts as a container and contains no logic. Instead, the children
 * passed in are responsible for the content and logic.
 */

// @ts-ignore
var Overlay = styled(Popover)(_templateObject(), function (props) {
  return props.theme.borderRadius.large;
}, function (props) {
  return props.theme.shadows.lgMedium;
}, function (props) {
  return props.theme.colors.white;
}); // @ts-ignore

var Arrow = styled(Popover.Arrow)(_templateObject2(), function (props) {
  return props.theme.colors.white;
});
var List = styled.ul(_templateObject3()); // @ts-ignore

var DropdownMenu = function DropdownMenu(_ref) {
  var children = _ref.children,
      className = _ref.className,
      hasArrow = _ref.hasArrow;
  return /*#__PURE__*/React.createElement(Overlay, {
    pos: "bottom",
    visible: true,
    className: className
  }, hasArrow && /*#__PURE__*/React.createElement(Arrow, {
    position: "top"
  }), /*#__PURE__*/React.createElement(List, {
    "data-testid": DROPDOWN_LIST
  }, children));
};

export { DropdownMenu };